// src/pages/FamilyDirectoryPage.js
import React from 'react';
import { Container, Typography, Box, Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Business as BusinessIcon, Home as HomeIcon } from '@mui/icons-material';
import FamilyDirectory from '../Components/FamilyDirectory';

const FamilyDirectoryPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link
          component="button"
          variant="body2"
          onClick={() => navigate('/')}
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          underline="hover"
          color="inherit"
        >
          <HomeIcon fontSize="small" />
          Home
        </Link>
        <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <BusinessIcon fontSize="small" />
          Family Directory
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BusinessIcon color="primary" />
          Family Business Directory
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Find services and professional expertise within your family. Connect with family members
          who can help with everything from home repairs to tax advice.
        </Typography>
      </Box>

      {/* Directory Component */}
      <FamilyDirectory />
    </Container>
  );
};

export default FamilyDirectoryPage;
